import React from 'react';
import { formatDuration, getTotalDuration } from '../utils/formatters';
import { VisualTimeline } from './VisualTimeline';
import { TimeEntry } from './TimeEntry';

export function TimelineView({
  todayEntries,
  currentTimer,
  currentTime,
  projects,
  editingEntry,
  editForm,
  getProjectById,
  onEditFormChange,
  onStartEdit,
  onSaveEdit,
  onCancelEdit,
  onDeleteEntry,
  onUpdateTimer,
  onUpdateTimerStartTime,
  onGapClick
}) {
  const getCurrentDuration = () => {
    if (!currentTimer) return 0;
    return currentTime - currentTimer.startTime;
  };

  if (todayEntries.length === 0 && !currentTimer) {
    return (
      <div>
        <h2 className="text-lg font-semibold text-gray-900 mb-4">Today's Timeline</h2>
        <div className="text-center py-12 text-gray-400">
          No time entries for today yet
        </div>
      </div>
    );
  }

  const allEntries = currentTimer ? [currentTimer, ...todayEntries] : todayEntries;

  return (
    <div>
      <h2 className="text-lg font-semibold text-gray-900 mb-4">Today's Timeline</h2>

      <div className="space-y-3">
        <VisualTimeline
          entries={todayEntries}
          currentTimer={currentTimer}
          currentTime={currentTime}
          getProjectById={getProjectById}
          onGapClick={onGapClick}
        />

        {allEntries.map((entry) => (
          <TimeEntry
            key={entry.id}
            entry={entry}
            project={getProjectById(entry.projectId)}
            projects={projects}
            currentTime={currentTime}
            isEditing={editingEntry === entry.id}
            editForm={editForm}
            onEditFormChange={onEditFormChange}
            onStartEdit={onStartEdit}
            onSaveEdit={onSaveEdit}
            onCancelEdit={onCancelEdit}
            onDelete={onDeleteEntry}
            onUpdateTimer={onUpdateTimer}
            onUpdateTimerStartTime={onUpdateTimerStartTime}
          />
        ))}

        {todayEntries.length > 0 && (
          <div className="pt-4 border-t border-gray-200 flex justify-between items-center">
            <span className="text-gray-600 font-medium">Total Today</span>
            <span className="text-xl font-bold text-gray-900">
              {formatDuration(getTotalDuration(todayEntries) + getCurrentDuration())}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
